module.exports = __webpack_public_path__ + "img/refreshicon.2c58c79f.svg";